module.exports = __webpack_public_path__ + "img/handraw_ordinateur_marron.dbd0bfaf.svg";